export const routes = {
  Dashboard: "/",
  AllPlans: "/plans",
  MyPlans: "/myplans",
  Library: "/library",
  CardDetails: ":cardId",
  sectionDetails: ":secId",
  InncodeUsers: "/inncodeUsers",
  PlanDetails: "/plandetails/:id",
  UserDashboard: "/userDashboard",
  PlanStats: "/planstats/:id/:listId",
  Recommendations: "/recommendations",
  MyPlanDetails: "/myplandetails/:id",
  IndividualProperty: "/property/:inncode",
  LibraryHallSearch: "/library/search",
  FunctionalArea: "/functionalArea/:id",
  InnCodeStats: "/inncodestats/:id/:listId",
  PlanProgress: "/planProgress",
  UserView: "/userview/:hltId"
};
